import customer from "./customer";
import delivery from "./delivery";
import person from "./person";
import payment from "./payment";
import requisites from "./requisites";
import step from "./step";
import {sendOrder} from "../../../api/order";

const orderStore = {
    namespaced: true,

    state: {
        errors: {},
        ...customer.state,
        ...delivery.state,
        ...payment.state,
        ...person.state,
        ...requisites.state,
        ...step.state
    },

    getters: {
        ...customer.getters,
        ...delivery.getters,
        ...payment.getters,
        ...person.getters,
        ...requisites.getters,
        ...step.getters,

        getOrderErrors: (state) => state.errors,

        isOrderComplete(state, getters) {
            return getters.isCompleteStep1 &&
                getters.isCompleteStep2 &&
                getters.isCompleteStep3
        },
        order(state, getters, rootState, rootGetters) {
            // return getters.getFinalRequisites
            return {
                billing: getters.getOrderDeliveryDetails,
                contact: state.recipientDetails,
                customer: state.customerDetails,
                deliveryType: state.selectedDelivery,
                items: rootGetters['shopCart/getOrderProducts'],
                payment_method: state.selectedPayment.type,
                promocode: null,
                requisites: state.requisites,
                requisites_file: state.requisitesFile,
                shipping: getters.getOrderDeliveryDetails,
            }
        },
    },
    mutations: {
        ...customer.mutations,
        ...delivery.mutations,
        ...payment.mutations,
        ...person.mutations,
        ...requisites.mutations,
        ...step.mutations,
        setErrors(state, payload) {
            state.errors = payload
        }
    },

    actions: {
        async sendOrder({state, getters, commit}) {
            try {
                if(getters.isOrderComplete)
                    return await sendOrder(getters.order)
                return null
            } catch (e) {
                !!e.response?.data?.errors &&
                commit('setErrors', e.response?.data?.errors)
            }
        }
    },

};
export default orderStore;
